import { configureStore } from "@reduxjs/toolkit";
import ApiDataSlice from "./Redux/ApiData/ApiDataSlice.jsx";
// import authReducer from './Redux/ApiData/AuthSlice.jsx'
const store = configureStore({
  reducer: {
    ApiData: ApiDataSlice,
    // auth: authReducer,
  },
});

export default store;
